import styled, { css } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  > * {
    padding: 4%;
  }

  ${({ background }) =>
    background === 'red' &&
    css`
      background-color: ${({ theme }) =>
        theme.color('shape-color-surface-tertiary')};
      color: ${({ theme }) => theme.color('shape-color-background-primary')};
    `}
`;

export default Container;
